exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".centered-spinner {\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n  text-align: center;\n  padding: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./node_modules/sass-resources-loader/lib/loader.js??ref--1-oneOf-3-3!./src/components/Utility/CenteredSpinner/index.scss
// module id = 1094
// module chunks = 1